import { DataSourceType } from '../core/data-sources';
// import { Shape } from "../core/global";
import { OrganisationDetails, Shape, ShapeOption } from '../core/global';


export const userShape: Shape[] = [
  {
    key: "first_name",
    title: "First name",
    required: true
  },
  {
    key: "last_name",
    title: "Last name",
    required: true
  },
  {
    key: "user_organisation",
    title: "Organisation"
  },
  {
    key: "job_title",
    title: "Job title"
  },
]

export const companyShape: Shape[] = [{
    key: "name",
    title: "Company name",
    required: true
  },
  {
    key: "vat_number",
    title: "VAT number",
  },
  {
    key: "address",
    title: "Address",
    required: true
  },
  {
    key: "address_2",
    title: "Address line 2",
  },
  {
    key: "address_3",
    title: "Address line 3",
  },
  {
    key: "city",
    title: "City",
    required: true
  },
  {
    key: "postcode",
    title: "Postcode",
  },
  {
    key: "country",
    title: "Country",
    required: true,
    type: 'country'
  },
  {
    key: "enforce_2fa",
    title: "Enforce 2 factor authentication",
    note: "All company members will be required to use 2 factor authentication when signing in.",
    type: 'checkbox'
  },
  {
    key: "vat_exempt",
    title: "V.A.T. Exempt",
    note: "MetOceanWorks Limited is a UK-based consultancy and is legally required to charge VAT on all our digital products. If you are exempt from paying VAT in the UK, please tick this box, and VAT will not be applied to your purchase.",
    type: 'checkbox'
  },
  {
    key: "members_pre_authorised",
    title: "All company members are pre-authorised to purchase",
    note: "All **members** will be able to purchase data using either subscription level of your account or other payment methods. This **does not apply to external users** who will need generate a request for data purchase approval.",
    type: 'checkbox',
    // showWhenTrue: ['super_subscriber']
  },
  {
    key: "super_subscriber",
    title: "Company is a super subscriber",
    note: "Super subscribers get nearly unlimited number of annual tokens (10,000) to use for data acquisitions.",
    type: 'checkbox',
    editable: false,
    showWhenTrue: ['super_subscriber']
  },
]

export const companySuperAdminShape: Shape[] = [
  {
    key: "name",
    title: "Company name",
    required: true
  },
  {
    key: "vat_number",
    title: "VAT number",
  },
  {
    key: "address",
    title: "Address",
    required: true
  },
  {
    key: "address_2",
    title: "Address line 2",
  },
  {
    key: "address_3",
    title: "Address line 3",
  },
  {
    key: "city",
    title: "City",
    required: true
  },
  {
    key: "postcode",
    title: "Postcode",
  },
  {
    key: "country",
    title: "Country",
    required: true,
    type: 'country'
  },
  {
    key: "enforce_2fa",
    title: "Enforce 2 factor authentication",
    note: "All company members will be required to use 2 factor authentication when signing in.",
    type: 'checkbox'
  },
  {
    key: "vat_exempt",
    title: "V.A.T. Exempt",
    type: 'checkbox'
  },
  {
    key: "members_pre_authorised",
    title: "All company members are pre-authorised to purchase",
    note: "All **members** will be able to purchase data using either subscription level of your account or other payment methods. This **does not apply to external users** who will need generate a request for data purchase approval.",
    type: 'checkbox',
  },
  {
    key: "super_subscriber",
    title: "Company is a super subscriber",
    note: "Super subscribers get nearly unlimited number of annual tokens (10,000) to use for data acquisitions.",
    type: 'checkbox',
    editable: true
  },
  {
    key: "can_upload_validations",
    title: "Company can upload custom validations",
    type: 'checkbox',
    editable: true
  },
  // {
  //   key: "can_raise_po",
  //   title: "Company can raise PO requests",
  //   type: 'checkbox',
  //   editable: true
  // },
]

export const roleOptions = [
  {key: 'external-user', value: 'Collaborator'},
  {key: 'member', value: 'Member'},
  {key: 'admin', value: 'Admin'}
]

export const createOrgUserShape: Shape[] = [{
  key: "email",
  title: "User e-mail",
  required: true
},
{
  key: "role",
  options: [...roleOptions],
  required: true,
  title: "Role",
}
]

export const createValidation: Shape[] = [
  {
    key: "name",
    title: "Name",
    required: true
  },
  {
    key: "data_source",
    options: [],
    required: true,
    title: "Data source",
  },
  {
    key: "lat",
    title: "Latitude",
    required: true
  },
  {
    key: "lon",
    title: "Longitude",
    required: true,
    note: "Location Latitude/Longitude (decimal or DMS)"
  },
]


export const createValidationSuperAdmin: Shape[] = [
  {
    key: "name",
    title: "Name",
    required: true
  },
  {
    key: "organisation_id",
    type: "multi-select",
    options: [],
    required: true,
    title: "Organisation",
  },
  {
    key: "data_source",
    options: [],
    required: true,
    title: "Data source",
  },
  {
    key: "lat",
    title: "Latitude",
    required: true
  },
  {
    key: "lon",
    title: "Longitude",
    required: true,
    note: "Location Latitude/Longitude (decimal or DMS)"
  },
]


export const createValidationItem: Shape[] = [
  {
    key: "file",
    title: "Upload validation file(s) (png or jpg). We recommend the image resolutions to be 2560 x 1440 pixels.",
    type: 'file',
    config: {
      accept: {
        'image/png': ['.png'],
        'image/jpeg': [ '.jpg', '.jpeg'],
        '': ['.png', '.jpg', '.jpeg'],
      },
      maxSize: 1e+8,   // 100MB
      maxFiles: 20
    },
    required: true,
  },
  {
    key: "type",
    options: [{
        key: 'waterlevel', 
        value: 'Water level'
      },
      {
        key: 'wind', 
        value: 'Wind'
      },
      {
        key: 'wave', 
        value: 'Wave'
      },
      {
        key: 'current', 
        value: 'Current'
      },
      {
        key: 'other', 
        value: 'Other'
      }
    ],
    required: true,
    title: "Type",
  },
  {
    key: "content",
    title: "Description",
    required: false,
    type: "textarea",
  },
]

export const requestPurchaseItemShape: Shape[] = [{
  key: "notes",
  title: "Message for approver",
  type: "textarea",
  required: false
},
]

export const resetPasswordShapeWithName: Shape[] = [
  {
    key: "first_name",
    title: "First name",
    required: true
  },
  {
    key: "last_name",
    title: "Last name",
    required: true
  },
  {
    key: "password",
    title: "Password",
    type: 'password',
    required: true
  },
  {
    key: "password_two",
    title: "Re-type password",
    type: 'password',
    required: true,
    note: 'Your password must be at least 6 characters long and contain both letters and numbers.'
  },
]

export const resetPasswordShape: Shape[] = [
  {
    key: "password",
    title: "Password",
    type: 'password',
    required: true
  },
  {
    key: "password_two",
    title: "Re-type password",
    type: 'password',
    required: true,
    note: 'Your password must be at least 6 characters long and contain both letters and numbers.'
  },
]

export const resetPasswordExistingUserShape: Shape[] = [
  {
    key: "existing_password",
    title: "Existing password",
    type: 'password',
    required: true
  },
  {
    key: "password",
    title: "Password",
    type: 'password',
    required: true
  },
  {
    key: "password_two",
    title: "Re-type password",
    type: 'password',
    required: true,
    note: 'Your password must be at least 6 characters long and contain both letters and numbers.'
  },
]

export const userEmailShape: Shape[] = [{
  key: "email",
  title: "E-mail address",
  required: true
}]


export const signUpShape: Shape[] = [
  {
    key: "email",
    title: "E-mail address",
    required: true
  },
  {
    key: "first_name",
    title: "First name",
    required: true
  },
  {
    key: "last_name",
    title: "Last name",
    required: true
  },
  {
    key: "user_organisation",
    title: "Organisation"
  },
  {
    key: "job_title",
    title: "Job title"
  },
  {
    key: "password",
    title: "Password",
    type: 'password',
    required: true
  },
  {
    key: "password_two",
    title: "Re-type password",
    type: 'password',
    required: true,
    note: 'Your password must be at least 6 characters long and contain both letters and numbers.'
  },
]


export const addressShape: Shape[] = [{
  key: "name",
  title: "Person's or Company name",
  required: true
},
{
  key: "address",
  title: "Address",
  required: true
},
{
  key: "address_2",
  title: "Address line 2",
},
{
  key: "address_3",
  title: "Address line 3",
},
{
  key: "city",
  title: "City",
  required: true
},
{
  key: "postcode",
  title: "Postcode",
},
{
  key: "country",
  title: "Country",
  required: true,
  type: 'country'
},
{
  key: "default_address",
  title: "This is a default address",
  type: 'checkbox'
},
]


export const simpleAddressShape: Shape[] = [{
  key: "name",
  title: "Person's or Company name",
  required: true
},
{
  key: "address",
  title: "Address",
  required: true
},
{
  key: "address_2",
  title: "Address line 2",
},
{
  key: "address_3",
  title: "Address line 3",
},
{
  key: "city",
  title: "City",
  required: true
},
{
  key: "postcode",
  title: "Postcode",
},
{
  key: "country",
  title: "Country",
  required: true,
  type: 'country'
},
]

export const projectShape: Shape[] = [{
  key: "name",
  title: "Project name",
  required: true
},
{
  key: "description",
  title: "Project description",
  type: "textarea"
},
// {
//   key: "region-of-interest",
//   title: "Region of interest",
//   type: "multi-select",
//   options: [{
//     key: 'all-wind',
//     value: 'All wind',
//   }, {
//     key: 'ijmuiden',
//     value: 'IJmuiden',
//   }, {
//     key: 'OWF',
//     value: 'Dowsing Offshore wind farm'
//   }]
// }
]


export const createPointShape: Shape[] = [{
  key: "lat",
  title: "Latitude",
  required: true
},{
  key: "lon",
  title: "Longitude",
  required: true,
  note: "Location Latitude/Longitude (decimal or DMS)"
},
]


export const latLonShapeWithName: Shape[] = [{
  key: "name",
  title: "Data point name",
  required: true
},{
  key: "lat",
  title: "Latitude",
  required: true
},{
  key: "lon",
  title: "Longitude",
  required: true,
},
{
  key: "description",
  title: "Optional data point description",
  type: "textarea"
}
]

export const userProfileShape: Shape[] = [
  {
    key: "first_name",
    title: "First name",
    required: true
  },
  {
    key: "last_name",
    title: "Last name",
    required: true
  },
  {
    key: "email",
    title: "E-mail address",
    note: "The E-mail address is connected to your account and cannot be changed.",
    editable: false,
  },
  {
    key: "notifications",
    title: "Enable notifications",
    note: "You can mute email communications from us in your account settings.",
    type: 'checkbox'
  },
  {
    key: "enable_2fa",
    title: "Enable 2 factor authentication on login",
    type: 'checkbox'
  },
]


export const userProfileShapeSuperAdmin: Shape[] = [
  {
    key: "first_name",
    title: "First name",
    required: true
  },
  {
    key: "last_name",
    title: "Last name",
    required: true
  },
  {
    key: "email",
    title: "E-mail address",
    note: "The E-mail address is connected to user account, change with caution.",
    editable: true,
  },
  {
    key: "notifications",
    title: "Enable notifications",
    note: "Mute email communications.",
    type: 'checkbox'
  },
  {
    key: "enable_2fa",
    title: "Enable 2 factor authentication",
    note: "Enable 2FA for this user on login.",
    type: 'checkbox'
  },
]

export const loginShape: Shape[] = [
  {
    key: "email",
    title: "E-mail address",
    required: true
  },
  {
    key: "password",
    title: "Password",
    type: 'password',
    note: 'Your password must be at least 6 characters long and contain both letters and numbers.',
    required: true
  },
  {
    key: "rememberMe",
    title: "Remember me (30 days)",
    type: 'checkbox'
  },
]

export const minMaxShape: Shape[] = [
  {
    key: "min",
    title: "Min",
    required: true
  },
  {
    key: "max",
    title: "Max",
    required: true
  },
  {
    key: "reverse_colors",
    title: "Reverse colours",
    type: 'checkbox'
  },
  {
    key: "show_bands",
    title: "Show bands",
    type: 'checkbox'
  }
]


export const tokenShape: Shape[] = [
  {
    key: "use_expiry_date",
    title: "Set expiry date",
    note: "When **unchecked**, the token will **never expire**.",
    type: 'checkbox',
  },
  {
    key: "expiry_at",
    title: "Token expiry date",
    type: 'date',
    showWhenTrue: ['use_expiry_date']
  },
]

// Keep as example
export const repeatableGroupExample: Shape[] = [
  {
    "key": "vertical_interpolation_levels",
    "title": "Vertical interpolation Levels",
    "type": "repeatable-group",
    "config": {
      "min": 1,
      "max": 8,
      "selectorLabel": "Vertical interpolation Levels",
      "itemLabel": "Level",
      "fields": [
        {
          "key": "level",
          "title": "Level",
          "required": true,
          "placeholder": "50, 60 , 100, 150, 250, 300"
        }
      ]
    }
  }
]


export const twoFactorShape: Shape[] = [
  {
    key: "code",
    title: "6-digit code",
    placeholder: "Enter your code",
    required: true,
    note: "Enter the code we just emailed you. It expires in 15 minutes.",
  },
]


const toOption = (value: string | number, label: string): ShapeOption => ({
  key: value,
  value: label,
});

export const dataSourceShape = (organisations: OrganisationDetails[] = []): Shape[] => [
  // --- Identity ------------------------------------------------------------
  { key: 'provider', title: 'Provider', required: true, placeholder: 'ERA5' },
  { key: 'model', title: 'Model', required: true },
  { key: 'geography', title: 'Geography', required: true },
  { key: 'version', title: 'Version' },
  {
    key: 'full_name',
    title: 'Display name',
    note: 'Shown to users in the model picker.',
  },
  { key: 'description', title: 'Description', type: 'textarea' },
  {
    key: 'export_description',
    title: 'Description on exports',
    type: 'textarea',
    note: 'Written into the header of exported files.',
  },
  {
    key: 'attribution',
    title: 'Attribution',
    type: 'textarea',
    note: 'Credit line the data provider requires.',
  },
  {
    key: 'bounds',
    title: 'Area bounds',
    type: 'textarea',
    note: 'Use MULTIPOLYGON in SRID 4326.',
  },
  // --- Storage -------------------------------------------------------------
  {
    key: 'source',
    title: 'Storage backend',
    options: [toOption('azure', 'Azure'), toOption('s3', 'S3')],
    defaultValue: 'azure',
  },
  {
    key: 'source_path',
    title: 'Container or path',
    note: 'Resolved at request time, so this can change without a deploy.',
  },
  {
    key: 'access_token_name',
    title: 'Access token name',
    note: 'Name of the SAS token entry used to read this container.',
  },
  { key: 'table_name', title: 'Table name' },
  { key: 'format', title: 'File format' },
  { key: 'regular', title: 'Regular grid', type: 'checkbox' },
  {
    key: 'filename_prefix',
    title: 'Filename prefix',
    // // Mirrors data_sources_regular_needs_prefix, which only bites when regular
    // // is on and a table name is set.
    // showWhenTrue: ['regular'],
    placeholder: 'ERA5_',
    // note: 'Include the separator: "ERA5_", not "ERA5". Required once a table name is set.',
  },
  {
    key: 'encrypted_filenames',
    title: 'Encrypted filenames',
    type: 'checkbox',
    note: 'On uses the S/N/E/W naming convention (e.q. S59600N000500E), off uses 4dp with a "p" separator (e.q. ERA5_55p0000N_000p2500E).',
  },

  // --- Access --------------------------------------------------------------
  { 
    key: 'requires_login', 
    title: 'Only users with account can access', 
    type: 'checkbox',
    note: 'User must be logged in to access this data source.',
  },
  {
    key: 'is_private',
    title: 'Private (Select organisations below to grant access)',
    type: 'checkbox'
  },
  {
    key: 'owner_organisation_id',
    title: 'Owner organisations',
    type: 'multi-select',
    options: organisations.map((o) => toOption(Number(o.id), o.name)),
  },
  {
    key: 'tokens_cost_per_year',
    title: 'Tokens per year',
  },

  // --- Coverage ------------------------------------------------------------
  { key: 'start_date', title: 'Start date (timestamps)' },
  { key: 'end_date', title: 'End date (timestamps)' },
  {
    key: 'start_date_parts',
    title: 'Start date parts',
    note: 'Comma-separated timestamps, one per part of a split archive.',
  },
  {
    key: 'end_date_parts',
    title: 'End date parts',
    note: 'Comma-separated timestamps, matched positionally to the start parts.',
  },
  {
    key: 'resolution',
    title: 'Resolution label - display only',
    note: 'Display label, e.g. "0.25°". Grid resolution below is what the maths uses.',
  },
  {
    key: 'grid_resolution',
    title: 'Grid resolution',
    placeholder: '0.25, 0.25',
    note: 'Comma-separated degrees, longitude then latitude.',
  },
  { key: 'frequency', title: 'Frequency (hours)' },
  { key: 'vertical_reference', title: 'Vertical reference' },
  { key: 'temporal_reference', title: 'Temporal reference' },
  { key: 'has_averages', title: 'Has averages', type: 'checkbox' },

  // --- Map -----------------------------------------------------------------
  { key: 'tiles_domain', title: 'Tiles domain' },
  { key: 'vector_tiles', title: 'Vector tiles' },

  // --- Advanced ------------------------------------------------------------
  {
    key: 'config',
    title: 'Config',
    type: 'json',
    note: 'Used by the proxy.',
  },
  {
    key: 'options',
    title: 'Options (used to acquire data)',
    type: 'json',
    note: 'This is a form object that sets the fields in the data acquisition journey.',
  },
];

export const dataSourceLayerShape: Shape[] = [
  { key: 'order', title: 'Order', note: 'In increments of 10.' },
  { key: 'title', title: 'Title', required: true },
  {
    key: 'short_name',
    title: 'Short name',
    note: 'Used where the full title does not fit, such as the legend.',
  },
  {
    key: 'key',
    title: 'Key',
    required: true,
    note: 'Use "model-grid" for the grid layer, and hide it from the layers list.',
  },
  { key: 'units', title: 'Units' },
  { key: 'format', title: 'Value format' },
  { key: 'min_value', title: 'Minimum value' },
  { key: 'max_value', title: 'Maximum value' },
  { key: 'min_value_label', title: 'Minimum label' },
  { key: 'max_value_label', title: 'Maximum label' },
  { key: 'url', title: 'Tile URL' },
  { key: 'data_url', title: 'Data URL' },
  { key: 'show_bands', title: 'Show bands', type: 'checkbox' },
  { key: 'hide', title: 'Hide from layers list', type: 'checkbox' },
  {
    key: 'colours',
    title: 'Colours',
    type: 'json',
    note: 'Validated as you type; Save stays disabled until it parses.',
  },
];

export const dataSourceVectorShape = (types: DataSourceType[]): Shape[] => [
  { key: 'order', title: 'Order', note: 'In increments of 10.' },
  { key: 'name', title: 'Name', required: true },
  {
    key: 'key',
    title: 'Key',
    required: true,
    note: 'The schema response is keyed on this. Changing it on a live source breaks existing downloads.',
  },
  { key: 'mat_key', title: 'MATLAB key' },
  {
    key: 'type_id',
    title: 'Type',
    options: types.map((t) => toOption(t.id, t.name || t.type || `#${t.id}`)),
  },
  { key: 'units', title: 'Units' },
  { key: 'directional', title: 'Directional', type: 'checkbox' },
  { key: 'categorical', title: 'Categorical', type: 'checkbox' },
  { key: 'has_height', title: 'Height resolved', type: 'checkbox' },
  { key: 'description', title: 'Description', type: 'textarea' },
];

export const dataSourceTypeShape: Shape[] = [
  { key: 'type', title: 'Type', required: true },
  { key: 'name', title: 'Name', required: true },
  { key: 'mat_key', title: 'MATLAB key' },
  { key: 'description', title: 'Description', type: 'textarea' },
];